"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantConversationRowDto = void 0;
class AssistantConversationRowDto {
}
exports.AssistantConversationRowDto = AssistantConversationRowDto;
//# sourceMappingURL=AssistantConversationRow.dto.js.map